export enum MarketplaceProgrammeVisitedSource {
  Banner = 'Banner',
  Card = 'Card',
  Popup = 'Popup',
  ProductPage = 'Product Page'
}

export enum ProgrammeViewEventKind {
  BannerShown = 'Banner shown',
  ModalShown = 'Calendly modal shown',
  PopupShown = 'Pop up shown',
  PopupDismissed = 'Pop up dismissed'
}

export enum PageViewSource {
  AppStore = 'App store',
  Profile = 'Profile page',
  Home = 'Home page',
  Donations = 'Donations page',
  GoogleAdGrants = 'Google Ad Grants page',
  MyDiscounts = 'My discounts',
  Marketplace = 'Marketplace',
  ProductOfferDetail = 'Product Offers',
  SavingsCalculator = 'Savings calculator',
  Users = 'Users page',
  DonationForm = 'Donation form page',
  AiGateway = 'AI gateway page',
  Volunteering = 'Volunteering page',
  VolunteeringCreateOpportunity = 'Volunteering create opportunity page',
  VolunteeringEditOpportunity = 'Volunteering edit opportunity page',
  Grants = 'Grants page',
  GrantDetails = 'Grant details page',
  Payouts = 'Payouts page',
  PayoutDetails = 'Payout details page',
  MyAccount = 'My account page'
}

export enum ProgramGenericEventKind {
  ButtonClicked = 'Button clicked',
  Viewed = 'Viewed'
}

export enum OriginCategory {
  AppStoreCarousel = 'App Store Carousel',
  Dashboard = 'Dashboard',
  ProductOfferDetail = 'Product Offer Detail Page'
}

export const metadataKeys = ['originCategory', 'offerName', 'offerType', 'hasBuyNowOption'] as const

export type MarketingMetadataKey = typeof metadataKeys[number]

export type MarketingMetadataKeyStore = MarketingMetadataKey | 'buttonText'

export enum ProgramName {
  // Partner
  AdobeAcrobatPro = 'ADOBE_ACROBAT_PRO',
  AdobeExpress = 'ADOBE_EXPRESS',
  Airslate = 'AIRSLATE',
  Claude = 'CLAUDE',
  Asana = 'ASANA',
  Atlassian = 'ATLASSIAN',
  Auth0 = 'AUTH0',
  Box = 'BOX',
  Canva = 'CANVA',
  ConstantContact = 'CONSTANT_CONTACT',
  Docusign = 'DOCUSIGN',
  EasyBoard = 'EASY_BOARD',
  Eventbrite = 'EVENTBRITE',
  Fiverr = 'FIVERR',
  Givebutter = 'GIVEBUTTER',
  Google = 'GOOGLE',
  GrantSourcing = 'GRANT_SOURCING',
  Gusto = 'GUSTO',
  Hootsuite = 'HOOTSUITE',
  HootsuiteSocialMedia = 'HOOTSUITE_SOCIAL_MEDIA',
  HootsuiteWebinar = 'HOOTSUITE_WEBINAR',
  LinkedInFundraise = 'LINKEDIN_FUNDRAISE',
  LinkedInHire = 'LINKEDIN_HIRE',
  Lovable = 'LOVABLE',
  Microsoft = 'MICROSOFT',
  Microsoft365BusinessPremium = 'MICROSOFT_365_BUSINESS_PREMIUM',
  Microsoft365Copilot = 'MICROSOFT_365_COPILOT',
  MicrosoftAzureGrant = 'MICROSOFT_AZURE_GRANT',
  MicrosoftPowerApps = 'MICROSOFT_POWER_APPS',
  MicrosoftManagement = 'MICROSOFT_MANAGEMENT',
  MondayCom = 'MONDAY_COM',
  N2F = 'N2F',
  NewRelic = 'NEW_RELIC',
  NordLayer = 'NORDLAYER',
  Okta = 'OKTA',
  OpenAI = 'OPENAI',
  Sage = 'SAGE',
  Splunk = 'SPLUNK',
  Twilio = 'TWILIO',
  QuickBooks = 'QUICKBOOKS',
  Workvivo = 'WORKVIVO',
  Zoom = 'ZOOM',
  Bugle = 'BUGLE',
  Keela = 'KEELA',
  AiForCommunity = 'AI_FOR_COMMUNITY',

  // Service
  GoogleAdGrant = 'GOOGLE_AD_GRANT',
  GoogleWorkspace = 'GOOGLE_WORKSPACE',
  ManagedIT = 'MANAGED_IT',
  ProfessionalGrantWriters = 'PROFESSIONAL_GRANT_WRITERS',
  SocialMedia = 'SOCIAL_MEDIA',
  AccountingFinancial = 'ACCOUNTING_FINANCIAL_SERVICES',
  WebCMS = 'WEB_CMS_SUPPORT',
  Fundraising = 'FUNDRAISING_SUPPORT',
  Ping = 'PING',
  DataMigrations = 'DATA_MIGRATIONS',
  GoogleAdGrantTrainingCourse = 'GOOGLE_AD_GRANT_TRAINING_COURSE',
  GrantPreparationBootcamp = 'GRANT_PREPARATION_BOOTCAMP',
  YouDoGoodMarketing = 'YOU_DO_GOOD_MARKETING'
}

export enum CategoryName {
  TopTools = 'TOP_TOOLS',
  ExpertServices = 'EXPERT_SERVICES',
  DiscountedSoftware = 'DISCOUNTED_SOFTWARE',
  GrowthExperiment = 'GROWTH_EXPERIMENT'
}

/** Marketplace analytics ids — values from CMS or callers as plain strings (no enum coercion). */
export type ProgramTracking = {
  name: string
  category: string
}
